/** Service Desk console: Settings -> Connectors (SD-SC-17), part D: import wizard and inbound hooks. */
export const serviceConnectorsD = {
  import: {
    title: "Mag-import ng API",
    subtitle: "Lumikha ng connector at mga operation nito mula sa OpenAPI o Swagger file, Postman collection o curl command.",
    subtitleExisting: "Magdagdag ng mga operation sa {{name}} mula sa OpenAPI o Swagger file, Postman collection o curl command.",
    stepsLabel: "Mga hakbang ng import",
    stepDone: "(tapos na)",
    stepOf: "Hakbang {{step}} sa {{count}} · {{name}}",
    steps: { source: "Pinagmulan", operations: "Mga operation na nahanap", auth: "Auth at mga environment", review: "Suriin at likhain" },
    sources: {
      openapi: { title: "OpenAPI / Swagger", hint: "JSON o YAML file, o pampublikong HTTPS URL." },
      postman: { title: "Postman collection", hint: "Export ng collection v2.1." },
      curl: { title: "Isang curl command", hint: "Ang isang request ay nagiging isang operation." },
    },
    whereDocs: "Nasaan ang API docs?",
    how: "Paano ito ibibigay",
    paste: "I-paste o i-upload",
    fromUrl: "Mula sa URL",
    contentLabel: "Dokumento",
    contentHint: "I-paste ang JSON o YAML, o mag-upload ng file hanggang {{mb}} MB. Hindi sinusundan ang mga external na reference.",
    contentRequired: "I-paste ang dokumento o mag-upload ng file.",
    upload: "Mag-upload ng file",
    fileRead: "Nabasa ang {{name}}",
    tooLarge: "Masyadong malaki ang file. Hanggang {{mb}} MB lang ang mga spec: hatiin ito o alisin ang mga halimbawa.",
    urlLabel: "URL ng spec",
    urlHint: "Pampublikong HTTPS address. Kinukuha sa pamamagitan ng parehong bantay ng bawat tawag.",
    curlLabel: "curl command",
    curlHint: "Inaalis ang mga header na may dalang credential; idadagdag mo ang secret sa hakbang 3.",
    curlRequired: "Mag-paste ng isang curl command na may https:// URL.",
    read: "Basahin ang dokumento",
    found_one: "{{count}} operation ang nahanap",
    found_other: "{{count}} operation ang nahanap",
    stripped_one: "{{count}} halimbawang halaga ang mukhang secret at inalis. Idagdag ang mga credential sa susunod na hakbang; naka-seal ang mga ito, hindi kailanman iniimbak sa mga operation.",
    stripped_other: "{{count}} halimbawang halaga ang mukhang secret at inalis. Idagdag ang mga credential sa susunod na hakbang; naka-seal ang mga ito, hindi kailanman iniimbak sa mga operation.",
    truncated: "Mas maraming operation ang nahanap kaysa sa itinatago. I-import ang iba mula sa mas maliit na file.",
    warnings_one: "{{count}} bagay na dapat tingnan",
    warnings_other: "{{count}} bagay na dapat tingnan",
    warning: {
      document_truncated: "Pinutol ang dokumento dahil napakalaki nito.",
      operations_truncated: "Ang mga unang operation lang ang itinago.",
      params_truncated: "May mga parameter na hindi isinama.",
      server_url_refused: "Tinanggihan ang isang server address (hindi pampublikong HTTPS).",
      no_server_url: "Walang binanggit na server address ang dokumento: ilagay ang base URL sa hakbang 3.",
      path_refused: "Tinanggihan ang isang path (dot segment o pangalawang host).",
      method_unsupported: "Nilaktawan ang method na hindi tinatawagan ng Sagot.",
      auth_scheme_unsupported: "Hindi na-map ang isang authentication scheme: itakda ito nang mano-mano.",
      cookie_param_ignored: "Binalewala ang isang cookie parameter.",
      header_param_ignored: "Binalewala ang isang header parameter (galing sa naka-seal na authentication ang mga credential).",
      secret_stripped: "Inalis ang halimbawang halaga na mukhang secret.",
      template_syntax_removed: "Pinawalang-bisa ang tekstong mukhang template sa dokumento.",
      pattern_dropped: "Tinanggal ang isang pattern ng halaga.",
      schema_simplified: "Pinasimple ang isang masalimuot na schema.",
      recursive_schema: "Pinutol ang isang schema na tumutukoy sa sarili.",
      ref_unresolved: "Hindi ma-resolve ang isang reference.",
      instruction_like_text: "Inalis sa paglalarawan ang tekstong mukhang utos.",
      file_upload_ignored: "Binalewala ang isang field ng file upload.",
      file_reference_ignored: "Binalewala ang isang reference sa file.",
      body_unsupported: "Nilaktawan ang uri ng body na hindi ipinapadala ng Sagot.",
    },
    tableLabel: "Mga operation na nahanap",
    selectAll: "Piliin ang lahat ng operation",
    pick: "I-import ang {{key}}",
    keyTaken: "Ginagamit na ang key: papalitan ang pangalan",
    writeNote: "Pumapasok bilang mga draft ang mga operation na nagbabago ng data at wala pang puwedeng tumawag. Ikaw ang pipili kung sino ang maaaring tumawag sa bawat isa, saka ilathala.",
    noneTitle: "Walang ii-import",
    noneBody: "Walang nahanap na operation sa dokumentong ito. Suriin ang file at subukan muli.",
    back: "Bumalik",
    next: "Susunod",
    productionUrl: "Production base URL",
    sandboxUrl: "Sandbox base URL (opsyonal)",
    sandboxHint: "Kung maglalagay ka, sa sandbox magsisimula ang mga tawag.",
    schemes: "Mga authentication scheme sa dokumento",
    schemesHint: "Pumili ng isa para mapunan ang authentication sa ibaba.",
    pickScheme: "Pumili ng scheme",
    secretsTitle: "Mga secret",
    secretsNote: "Tina-type dito, sine-seal sa vault kapag nalikha ang connector at hindi na muling ipinapakita. Maaari mo ring itakda ang mga ito mamaya.",
    secretFor: "Halaga para sa {{slot}}",
    environments: "Mga environment",
    secretsSealed_one: "{{count}} secret ang isi-seal",
    secretsSealed_other: "{{count}} secret ang isi-seal",
    secretsLater: "Wala pa: itakda sa connector",
    selected_one: "{{count}} operation ang napili",
    selected_other: "{{count}} operation ang napili",
    addTo: "Idagdag sa",
    reviewNote: "Nalilikha bilang draft hanggang masubukan mo ang isang operation. May paglalarawan para sa assistant ang bawat operation na dapat mong suriin.",
    reviewExisting: "Idinaragdag bilang mga draft ang mga operation. Suriin ang bawat isa, subukan, saka ilathala.",
    create: "Likhain ang connector",
    addOperations_one: "Magdagdag ng {{count}} operation",
    addOperations_other: "Magdagdag ng {{count}} operation",
    created_one: "Nalikha ang {{name}} na may {{count}} operation",
    created_other: "Nalikha ang {{name}} na may {{count}} operation",
    added_one: "{{count}} operation ang naidagdag",
    added_other: "{{count}} operation ang naidagdag",
  },
  hooks: {
    intro: "Tinatawagan ng system ng customer ang isang address ng Sagot kapag may nangyari (naipadala ang order, nagbago ang record). Bawat tawag ay bine-beripika, sinasala ang duplicate at ginagawang event na maaaring magsimula ng workflow.",
    add: "Magdagdag ng inbound endpoint",
    edit: "I-edit ang {{key}}",
    emptyTitle: "Walang inbound webhook",
    emptyBody: "Hindi pa nagpapadala ng event sa Sagot ang {{name}}. Magdagdag ng endpoint kapag kaya ng system na tumawag ng URL tuwing may pagbabago.",
    lockTitle: "Kasama ang mga inbound webhook mula sa Pro plan",
    lockBody: "Hayaang magtulak ng event sa Sagot ang mga system mo at magsimula ng mga workflow sa sandaling may magbago. I-upgrade para buksan ang mga inbound webhook.",
    dialogHint: "Kung paano pinatutunayan ng nagpapadala kung sino siya at kung paano nagiging event ang payload niya. Sa Secrets itinatakda ang halaga ng secret, sa slot na papangalanan mo.",
    key: "Key ng endpoint",
    keyHint: "Bahagi ng address; hindi na ito mababago mamaya.",
    enabled: "Naka-enable",
    enabledAria: "I-enable ang {{key}}",
    profile: "Beripikasyon",
    profiles: { standard_webhooks: "Standard Webhooks", generic_hmac: "Generic HMAC", shared_secret_header: "Shared secret header", basic: "HTTP Basic" },
    profileAbout: {
      standard_webhooks: "HMAC-SHA256 sa id, timestamp at body, na may 300 segundong tolerance.",
      generic_hmac: "HMAC sa body sa header na papangalanan mo.",
      shared_secret_header: "Inuulit ng nagpapadala ang shared secret sa isang header.",
      basic: "User name at password na nasa vault.",
    },
    secretSlot: "Secret slot",
    secretSlotHint: "Itakda ang halaga nito sa Secrets. inbound_secret ang default.",
    username: "User name",
    header: "Header",
    headerHint: "Iwanang walang laman para sa default.",
    algorithm: "Algorithm",
    encoding: "Encoding ng pirma",
    prefix: "Teksto bago ang pirma",
    prefixHint: "Tulad ng sha256=",
    payload: "Ano ang pinipirmahan",
    timestampHeader: "Header ng timestamp",
    ipAllowlist: "Mga pinapayagang source address (opsyonal)",
    ipAllowlistHint: "Mga network o address na pinaghihiwalay ng espasyo. Tumatanggap ng kahit anong source kapag walang laman.",
    eventFrom: "Pangalan ng event mula sa",
    eventFromBody: "Isang field ng body",
    eventFixed: "Isang nakapirming pangalan",
    eventName: "Pangalan ng event",
    eventNameHint: "Maliliit na titik, tulad ng order.shipped.",
    eventPointer: "Field na may pangalan ng event",
    eventPointerHint: "Pointer sa JSON body, tulad ng /type.",
    deliveryId: "Field ng delivery id (opsyonal)",
    deliveryIdHint: "Ang sariling id ng nagpapadala, ginagamit para alisin ang mga duplicate sa loob ng 7 araw.",
    allow: "Mga inaasahang event (opsyonal)",
    allowHint: "Itinatago para suriin ang ibang event pero wala itong sinisimulan.",
    dataFields: "Mga data field",
    dataFieldsShort: "Data para sa mga workflow",
    dataFieldsHint: "Nagiging connector.data.<pangalan> ang bawat field sa workflow na sinimulan ng event.",
    dataName: "Pangalan ng data field {{index}}",
    dataSource: "Source ng data field {{index}}",
    dataRemove: "Alisin ang data field {{index}}",
    addField: "Magdagdag ng data field",
    problems: {
      key: "Gumamit ng maliliit na titik, numero, - at _, magsimula sa titik.",
      slot: "Gumamit ng maliliit na titik, numero at underscore para sa pangalan ng slot.",
      required: "Kailangan ang field na ito.",
      timestampHeader: "Pangalanan ang header na may dalang timestamp.",
      eventName: "Gumamit ng maliliit na titik, numero, tuldok, - at _.",
      dataName: "Gumamit ng maliliit na titik, numero at underscore.",
    },
    saved: "Na-save ang endpoint",
    secretSet: "May halaga na ang secret",
    secretMissing: "Itakda ang secret na \"{{slot}}\"",
    copyUrl: "Kopyahin ang URL",
    lastReceived: "Huling natanggap",
    limits: "Hanggang 256 KB kada body, may pirma at nasa loob ng 300 segundo, inaalis ang mga duplicate sa loob ng 7 araw. Tinatanggihan ng 401 ang mga walang pirma o huli na at walang pinoproseso.",
    showDeliveries: "Mga kamakailang delivery",
    hideDeliveries: "Itago ang mga delivery",
    deliveries: "Mga kamakailang delivery",
    noDeliveries: "Wala pang natatanggap.",
    signature: "Pirma",
    signatureOk: "Naberipika",
    signatureBad: "Nabigo",
    eventStatus: { received: "Natanggap", processed: "Naproseso", unmatched: "Walang tugma", rejected: "Tinanggihan", failed: "Nabigo" },
    deleteAria: "Burahin ang {{key}}",
    deleteTitle: "Burahin ang endpoint na {{key}}?",
    deleteBody: "Magkakaroon na ng error ang nagpapadala simula ngayon. Aalisin din ang mga nakaraang delivery.",
    deleteConfirm: "Burahin ang endpoint",
  },
};
